var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"box"}},[(_vm.screenWidth > 1366)?_c('pc'):_c('mobile')],1)}
var staticRenderFns = []

export { render, staticRenderFns }